import { Injectable } from '@angular/core';
import { Constants } from '@mp-core/enums/constants';
import { ApiService } from '@mp-core/services/api.service';
import { tap } from 'rxjs/operators';
import { BehaviorSubject, Observable } from 'rxjs';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class AuthService {

  private isAuthenticated = new BehaviorSubject<boolean>(false);
  constructor(private apiService: ApiService, private router: Router) {
  }

  requestOtp(email: string): Observable<{ message: string }> {
    return this.apiService.post<{ message: string }>('auth/sendOTPMail', { email });
  }

  verifyOtp(email: string, otp: string): Observable<{ token: string }> {
    return this.apiService.post<{ token: string }>('auth/verifyOTPMail', { email, OTP: +otp })
      .pipe(tap(res => {
        this._setToken(res.token);
        this.isAuthenticated.next(true);
      }));
  }

  signInUser(data: { phoneNumber: string }): Observable<{ token: string }> {
    return this.apiService.post<{ token: string }>('auth/signIn', data, false)
      .pipe(tap(res => this._setToken(res.token)));
  }

  getIsAuthenticated(): Observable<boolean> {
    return this.isAuthenticated.asObservable();
  }

  autoLogin() {
    this.isAuthenticated.next(true);
    this.router.navigateByUrl('/dashboard').then();
  }

  logout(): void {
    this.isAuthenticated.next(false);
    localStorage.removeItem(Constants.AUTH_TOKEN);
    localStorage.removeItem(Constants.CURRENT_USER_PHONE_NO);
    this.router.navigateByUrl('/').then();
  }

  _setToken(token: string) {
    localStorage.setItem(Constants.AUTH_TOKEN, token);
  }

  hasAuthToken(): boolean {
    return !!localStorage.getItem(Constants.AUTH_TOKEN);
  }
}
